import Vue from 'vue'
import Main from './main.vue'
import vuetify from '../../plugins/vuetify';

import MyDialog from '../../components/MyDialog.vue'

import MyLoading from '../../components/MyLoading.vue'
import MyAxios from '../../components/MyAxios.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faSearch)

Vue.component('MyLoading', MyLoading)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.mixin(MyDialog);
Vue.mixin(MyAxios);

new Vue({
    vuetify,
    render: h => h(Main)
}).$mount('#app')
